<img [src]="getSocialIcon()" [alt]="type" />
